<template>
  <PopupModal :open="open" has-close-button @close="close">
    <template #body>
      <div>
        <div>
          <AssistantSmiling class="mx-auto mb-8" />
        </div>
        <div class="text-large mb-8">
          {{ t("comp.challenge.teams.create.dialog.text") }}
        </div>
        <div>
          <InputElement
            id="team-name"
            v-model="name"
            type="text"
            max-length="20"
            :required="true"
            :label="t('comp.challenge.teams.create.dialog.inputhint')"
            :error-message="t('comp.challenge.teams.join.naming.error')"
            :validation="validateTeamName"
            :error-border="errorBorder"
            :show-input-length="true"
            @validation-state="handleValidationState"
          />
          <p v-if="errorMessage" class="mt-2 text-sm text-action-red">
            {{ errorMessage }}
          </p>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex flex-row w-full justify-center gap-4">
        <div class="text-center">
          <ButtonElement
            :label="
              t('comp.challenge.teams.create.dialog.cancel.button.caption')
            "
            :disabled-visible="true"
            @click="close"
          />
        </div>
        <div class="text-center">
          <ButtonElement
            :label="
              t('comp.challenge.teams.create.dialog.confirm.button.caption')
            "
            :disabled="!name || teamNameError"
            :class="[!name || teamNameError ? 'cursor-not-allowed' : '']"
            @click="create"
          />
        </div>
      </div>
    </template>
  </PopupModal>
</template>
<script setup lang="ts">
import PopupModal from "../layout/PopupModal.vue";
import ButtonElement from "../form/ButtonElement.vue";
import AssistantSmiling from "../icon/AssistantSmiling.vue";
import { useUserStore } from "../../../store/v2/user";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { createTeam } from "../../../api/v2/competitive-challenge.ts";
import InputElement from "../form/InputElement.vue";
const { t } = useI18n();

const router = useRouter();
const user = useUserStore();
const emit = defineEmits(["close", "updateHistory"]);

const name = ref("");
const teamNameError = ref(false);
const errorMessage = ref("");
const errorBorder = ref(false);

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  challengeId: {
    type: String,
  },
});

async function create() {
  errorMessage.value = "";
  const res = await createTeam(
    user.externalUserId,
    props.challengeId,
    name.value
  ).catch(() => {
    errorMessage.value = t("api.failure.message.there.is.an.error");
    errorBorder.value = true;

    return null;
  });

  if (res) {
    emit("close");
    router.push({
      name: "competitiveChallengeDetail",
      params: { challengeId: props.challengeId },
    });
  }
}

function close() {
  emit("close");
}

function validateTeamName(value) {
  errorMessage.value = null;
  if (value.length <= 0) {
    errorBorder.value = false;
    return true;
  }

  const regex = /^[a-zA-Z0-9äöüÄÖÜß!@#$%^&*?\[\]{}.,_#+()"'\\\s~|§\/=;:\-€]+$/;
  const isValid = regex.test(value);
  errorBorder.value = !isValid;

  return isValid;
}

function handleValidationState({ value, error }) {
  name.value = value;
  teamNameError.value = error;
}
</script>
